import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { GET_CAR_TYPE, GET_CAR_TYPE_EMPTY } from '../../../../../../../../store/actions';

const AddCarTypeModal = ({ onClose, state, handleYes }) => {
  const dispatch = useDispatch();

  const [carTypeList, setCarTypeList] = useState([]);
  const [selectedCarTypes, setSelectedCarTypes] = useState([]);

  const { getCarType } = useSelector((state: any) => ({
    getCarType: state.GetCarType.data,
  }));

  useEffect(() => {
    dispatch({ type: GET_CAR_TYPE });
  }, []);

  useEffect(() => {
    if (state?.client?.carTypes?.length > 0) {
      setSelectedCarTypes(state?.client?.carTypes ?? []);
    }
  }, [state]);

  useEffect(() => {
    if (getCarType !== null) {
      setCarTypeList(getCarType?.data ?? []);
      dispatch({ type: GET_CAR_TYPE_EMPTY });
    }
  }, [getCarType]);

  const handleCarTypeClick = type => {
    const isSelected = selectedCarTypes.some(selected => selected.id === type.id);
    const updatedTypes = isSelected ? selectedCarTypes.filter(t => t.id !== type.id) : [...selectedCarTypes, type];
    setSelectedCarTypes(updatedTypes);
  };

  return (
    <Modal isOpen={true} centered size="md">
      <ModalHeader toggle={onClose}>Add Car Type</ModalHeader>

      <ModalBody>
        <div className="d-flex flex-wrap gap-2">
          {carTypeList?.map((type, idx) => {
            const isSelected = selectedCarTypes.some(selected => selected.id === type.id);
            return (
              <div
                key={idx}
                onClick={() => handleCarTypeClick(type)}
                className="p-2 cursor-pointer"
                style={{
                  borderRadius: '25px',
                  color: '#6F7594',
                  border: isSelected ? '1px solid #405189' : '1px solid #D0D2DC',
                  background: isSelected ? '#ABB9E8' : 'transparent',
                  opacity: 1,
                }}
              >
                {type?.name?.split(' ')[0] ?? ''}
              </div>
            );
          })}
        </div>
      </ModalBody>

      <div className="d-flex justify-content-between mb-4 gap-3 mx-2 me-2">
        <Button color="primary w-100" style={{ fontSize: '14px', borderRadius: '5px' }} onClick={() => handleYes(selectedCarTypes)}>
          Yes
        </Button>

        <Button color="white w-100" style={{ fontSize: '14px', borderRadius: '5px', border: '1px solid #401589' }} onClick={onClose}>
          No
        </Button>
      </div>
    </Modal>
  );
};

export default AddCarTypeModal;
